import React from 'react';
import Content from 'src/components/Content';
import { Card } from '@material-ui/core';
import ContactsLedger from './ContactsLedger';

const ListContacts = () => (
  <Content title="Contacts" maxWidth="lg">
    <Card>
      <ContactsLedger />
    </Card>
  </Content>
);

export default ListContacts;
